module.exports = __webpack_public_path__ + "static/media/bottom_shape_2.767d38c0.svg";